<div class="container-fluid p-0 banner-campaign d-flex align-items-center justify-content-center" *ngIf="campaign as c">
  <img [src]="c.imageUrl || fallback" [alt]="c.nameEn || 'Banner Campaign Image'" />
</div>

<div class="campaign-summary-content" *ngIf="campaign">
  <h4 class="campaign-summary-title">
    {{ name }}
  </h4>

  <div class="campaign-description-wrapper" [class.campaign-desc--expanded]="showFullDescription"
    *ngIf="description">
    <p class="campaign-description-text">
      {{
      showFullDescription
      ? description
      : (description | truncateText: 260)
      }}
    </p>
  </div>

  <button *ngIf="description && description.length > 260" type="button" class="campaign-description-toggle"
    (click)="showFullDescription = !showFullDescription">
    {{
    showFullDescription
    ? ('CAMPAIGN.SeeLess' | translate)
    : ('CAMPAIGN.SeeMore' | translate)
    }}
  </button>
</div>